// Helper to select slices/apply transformation on redux state

export const getUser = (state) => state.user;
